// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-logo-wrapper {\n  width: 100%;\n  text-align: right;\n}\n.revico-logo {\n  height: 19px;\n  color: #bbb;\n  font-size: 10px;\n  text-decoration: none;\n}\n.revico-logo--note {\n  margin-right: 6px;\n  color: #bbb;\n  font-size: 10px;\n}\n.revico-logo--img {\n  height: 19px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
